import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import './OpalAddItemModal.css';
import { getAll } from "../../../../../localDB";
import { StockAllocationType } from "../../../../../visualizations/visualizations";

const OpalAddItemModal = ({ show, onHide, onAddSelected }) => {
  const [items, setItems] = useState([]);       // All items fetched
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (show) {
      const fetchData = async () => {
        try {
          const stock = await getAll("StockAllocations");
          const it = await getAll("item");

          const itemMap = Object.fromEntries(
            (it || []).map(i => [i.ID, i])
          );

          const sampleStocks = (stock || []).filter(
            s => s.Type === StockAllocationType.Samples
          );

          const result = (it || []).map(item => {
            const relatedStocks = sampleStocks.filter(
              s => s.ItemID === item.ID && s.UnitID === item.UnitID
            );

            const totalStock = relatedStocks.reduce(
              (sum, s) => sum + (s.Stock || 0),
              0
            );

            const totalAllocated = relatedStocks.reduce(
              (sum, s) => sum + (s.Allocated || 0),
              0
            );

            return {
              ItemID: item.ID,
              UnitID: item.UnitID,
              Code: item.Code,
              Description: item.Description,
              Stocks: totalStock,
              Allocated: totalAllocated
            };
          });

          setItems(result);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  }, [show]);

  const filteredItems = useMemo(() => {
    return items
      .filter(i =>
        !searchTerm.trim() ||
        i?.Code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        i?.Description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
  }, [items, searchTerm]);

  const handleSelect = (itm) => {
    setSelectedItems(prev =>
      prev.includes(itm)
        ? prev.filter(i => i !== itm)
        : [...prev, itm]
    );
  };

  const handleAddSelected = () => {
    onAddSelected(selectedItems);
    onHide();
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  useEffect(() => {
    if (!show) {
      setSelectedItems([]);
      setSearchTerm('');
      setItems([]);
    }
  }, [show]);

  return (
    <Modal className="opal-additem-modal" show={show} onHide={onHide} centered>
      <Modal.Header>
        <div className="modal-header-content">
          <div className="modal-title">Add Item</div>
          <div className="input-group search-input">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <table className="oaim-table">
          <thead className="oaim-table-header">
            <tr>
              <th></th>
              <th>Item Code</th>
              <th>Item Description</th>
              <th>Stocks</th>
              <th>Allocated</th>
            </tr>
          </thead>
          <tbody className="oaim-table-body">
            {filteredItems.map((item) => (
              <tr key={item.ID}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedItems.includes(item)}
                    onChange={() => handleSelect(item)}
                  />
                </td>
                <td>{item?.Code}</td>
                <td>{item?.Description}</td>
                <td>{item?.Stocks || 0}</td>
                <td>{item?.Allocated || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button-close" onClick={onHide}>
          Cancel
        </Button>
        <Button className="button-add" onClick={handleAddSelected}>
          Add Selected
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpalAddItemModal;